import { Directive } from '@angular/core';



export class MdlLayoutHeaderTransparentDirective {static decorators: DecoratorInvocation[] = [
{ type: Directive, args: [{
  selector: 'mdl-layout-header[mdl-layout-header-transparent]',
  host: {
    '[class.mdl-layout__header--transparent]': 'true'
  }
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
